import { useEffect, useState } from "react";
import api from "../services/api";


const statusMap = {
  PENDING: "در انتظار",
  FINISHED: "موفق",
  REJECTED : "ناموفق",
};

function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString("fa-IR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

const WithdrawList = () => {
  const [withdraws, setWithdraws] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/user/wallet/withdraws/")
      .then((res) => {
        setWithdraws(res.data);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="w-full mt-16 pb-4" dir="rtl">
      <div className="w-full md:w-[703px] px-6 md:px-0 mx-auto">
        <h2 className=" font-bold mb-6 text-white">
          لیست برداشت‌ها
        </h2>

        {loading ? (
          <div className="text-center text-gray-500">در حال بارگذاری...</div>
        ) : withdraws.length === 0 ? (
          <div className="text-center text-gray-400">
            هیچ برداشتی ثبت نشده است.
          </div>
        ) : (
          <div className="space-y-4">
            {withdraws.map((w, idx) => (
              <div
                key={idx}
                className="p-4 shadow rounded-2xl border border-[#243189] bg-gradient-to-t from-[#1D2766] to-[#171F52] flex flex-col md:flex-row justify-between items-start md:items-center gap-4"
              >
                <div>
                  <p className=" font-semibold text-[13px]">
                    مبلغ:{" "}
                    <span className="text-blue-300">
                      {w.amount.toLocaleString("fa-IR")}
                    </span>{" "}
                    تومان
                  </p>
                  <p className=" text-gray-400 mt-1 text-[13px]">
                    شماره کارت: {w.card_number}
                  </p>
                </div>

                <div className="flex flex-col items-center gap-1">
                  <span
                    className={`px-3 py-1 rounded-lg text-[13px] ${
                      w.status === "PENDING"
                        ? "bg-yellow-100 text-yellow-700"
                        : w.status === "FINISHED"
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {statusMap[w.status] || w.status}
                  </span>
                  <span className="text-[11px] text-gray-400">
                    {formatDate(w.created_at)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WithdrawList;
